module.exports = __webpack_public_path__ + "img/nayax_logo.eb09ebc5.svg";